import { useBlocksConfig } from "@pathwright/blocks-engine"
import AttachmentsList from "./AttachmentsList/AttachmentsList"
import { AttachmentsEditWrapper } from "./ui"
import {
  mediaToAttachment,
  mergeAttachments,
  unMergeAttachment,
  updateAttachment
} from "./utils"

export const AttachmentsEdit = ({ id, data, onChange }) => {
  const { theme } = useBlocksConfig()
  const handleAddAttachment = (mediaItem) => {
    const attachment = mediaToAttachment(mediaItem)
    const files = mergeAttachments(data.files, attachment)

    onChange({ files })
  }

  const handleRemoveAttachment = (attachmentToRemove, index) => {
    const files = unMergeAttachment(data.files, index)

    onChange({ files })
  }

  const handleUpdateAttachment = (updatedAttachment) => {
    const files = updateAttachment(data.files, updatedAttachment)

    onChange({ files })
  }

  return (
    <AttachmentsEditWrapper className="AttachmentsEdit">
      <AttachmentsList
        attachments={data.files}
        mode="edit"
        onRemoveAttachment={handleRemoveAttachment}
        onAddAttachment={handleAddAttachment}
        onUpdateAttachmentName={handleUpdateAttachment}
        onChange={onChange}
        theme={theme}
        // Allows us to have unique keys for React
        blockID={id}
      />
    </AttachmentsEditWrapper>
  )
}

export default AttachmentsEdit
